import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorBoundary from "error/ErrorBoundary";

const ProtectedRouteAdmin = ({
  component: Component,
  credential,
  isProtected = false,
  restoreKey, // Añadimos esta prop
  ...rest
}) => {
  const rules = useSelector((state) => state.login.rules);

  const getCredentials = (rule, isProtected) => {
    if (!isProtected) return true;
    return rules && rules.includes(rule);
  };
  return (
    <Route
      {...rest}
      render={(props) => {
        if (getCredentials(credential, isProtected)) {
          return (
            <ErrorBoundary restoreKey={restoreKey}>
              <Component {...rest} {...props} />
            </ErrorBoundary>
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: "/admin/dashboard",
                state: { from: props.location }
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRouteAdmin;